import type { SENDING_SKIPPED } from './consts'

export type AnalyticsLogger = {
  error: (...args: unknown[]) => void
  debug: (...args: unknown[]) => void
  warn?: (...args: unknown[]) => void
}

export type AnalyticsEntity = Record<string, unknown>

export type AnalyticsEventPayload = Record<string, unknown>

export type AnalyticsDispatchData = AnalyticsEntity & {
  name?: string
}

export type EventConverter = (event: AnalyticsEventPayload) => AnalyticsEventPayload

export type EventMiddleware = (event: AnalyticsEventPayload) => AnalyticsEventPayload

export type HandlerConfig = {
  name: string
  code?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- handler classes are mixed in via Object.assign
  handler: new (config: HandlerConfig, manager: AnalyticsManagerRef) => any
  eventConverters?: EventConverter[]
  eventMiddlewares?: Record<string, EventMiddleware>
  appConfig?: Record<string, unknown>
}

export type AnalyticsManagerRef = {
  logger: AnalyticsLogger
  webView?: string
  country?: string
  removeHandler: (handler: unknown) => void
  apiCall?: (config: Record<string, unknown>) => Promise<{ data: Record<string, unknown> }>
}

export type GtmDataLayer = AnalyticsEventPayload[] & {
  push: (event: AnalyticsEventPayload) => void
}

export type SegmentAnalytics = {
  track: (eventName: string, eventProps: Record<string, unknown>, settings?: Record<string, unknown>) => void
  identify: (userId: string, eventProps: Record<string, unknown>, settings?: Record<string, unknown>) => void
  reset: () => void
  user: () => { id: () => string | null }
}

export type WindowWithAnalytics = Window & Record<string, unknown> & {
  branch?: {
    getBrowserFingerprintId: (callback: (err: unknown, data: string) => void) => void
  }
}

export type GtmAppointmentHandlerContext = {
  logger?: { warn: (...args: unknown[]) => void }
}

export type GtmOnboardingHandlerContext = {
  cannotSendAppOpened: (args: { business: AnalyticsEntity }) => boolean
  getAppOpenedPayload: (args?: Record<string, unknown>) => unknown
  sendingSkipped: typeof SENDING_SKIPPED
}

export type SegmentOnboardingHandlerContext = {
  getFacebookSettings: () => Record<string, unknown>
}

export function getWindowAnalyticsHandler<T> (name: string): T | undefined {
  return (window as unknown as WindowWithAnalytics)[name] as T | undefined
}
